module.exports = __webpack_public_path__ + "static/img/doctor-icon.1b0efb23.png";